module.exports = __webpack_public_path__ + "images/emoji/walking.e800a8221f206709a729.png";